


<template lang="jade">

	div.app-content
		router-view

</template>









<script>



	const $cmp = {
		name : 'app-content',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.mounted = function() {

		let $this = this

	}



	$cmp.methods = {}



	export default $cmp



</script>









<style lang="stylus" scoped>

	.app-content
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		width 100%
		height 100%
		overflow-x hidden

</style>



// WEBPACK FOOTER //
// src/app-content.vue